import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Button,
  Col,
  Divider,
  Input,
  Modal,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
} from 'antd';
import { ControlOutlined, ExclamationCircleOutlined, PoweroffOutlined } from '@ant-design/icons';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import Progress from 'antd/lib/progress';
import { ClockCircleOutlined } from '@ant-design/icons';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { ArrayParam, useQueryParam } from 'use-query-params';
import { useParams } from 'react-router';
import { Link, useHistory } from 'react-router-dom';
import Form from '../../../../form/Form';
import MultipleToggle from '../../../../components/atoms/MultipleToggle';
import { PageHeader } from '@ant-design/pro-layout';
import { RichText } from '../../../../components/RichText/RichText';
import ReactHtmlParser from '../../../../utils/SafeHtmlParser';
const { Text } = Typography;
const { TextArea } = Input;

export const fullMark = (teams: any[]) => {
  let mark = 0;
  for (const team of teams) {
    const internalCustomers =
      team.internalCustomers &&
      team.internalCustomers?.answer !== null &&
      team.internalCustomers.answer * team.internalCustomers.percentage !== 0
        ? (team.internalCustomers.answer * team.internalCustomers.percentage) / 100
        : 0;
    const teamPerformance =
      team.teamPerformance &&
      team.teamPerformance?.answer !== null &&
      team.teamPerformance.answer * team.teamPerformance.percentage !== 0
        ? (team.teamPerformance.answer * team.teamPerformance.percentage) / 100
        : 0;
    const supervisorFeedBack =
      team.supervisorFeedBack &&
      team.supervisorFeedBack?.answer !== null &&
      team.supervisorFeedBack?.answer * team.supervisorFeedBack.percentage !== 0
        ? (team.supervisorFeedBack.answer * team.supervisorFeedBack.percentage) / 100
        : 0;
    const peerReviews =
      team.peerReviews &&
      team.peerReviews?.answer !== null &&
      team.peerReviews.answer * team.peerReviews.percentage !== 0
        ? (team.peerReviews.answer * team.peerReviews.percentage) / 100
        : 0;
    mark +=
      ((internalCustomers + teamPerformance + supervisorFeedBack + peerReviews) *
        team.cyclePercentage) /
      100;
  }
  return (
    (mark === 0 || isNaN(mark) ? 0 : mark / teams.reduce((sum, e) => sum + e.cyclePercentage, 0)) *
    100
  );
};

export const sectionMark = (teams: any[]) => {
  let mark = 0;
  for (const team of teams) {
    const section = team.section ? team.section.answer : 0;
    mark += (section * team.cyclePercentage) / 100;
  }
  return (mark === 0 ? 0 : mark / teams.reduce((sum, e) => sum + e.cyclePercentage, 0)) * 100;
};

const regex = /(<([^>]+)>)/gi;

const dataSet = (team: any, cycleSet: any[], user: any, userId: any) => {
  const cycles =
    team?.supervisorFeedBack?.data?.map((e: any) => e.cycle) ??
    team?.peerReviews?.data?.map((e: any) => e.cycle) ??
    team?.internalCustomers?.data?.map((e: any) => e.cycle) ??
    team?.teamPerformance?.data?.map((e: any) => e.cycle) ??
    team?.supervisorFeedBack?.data?.map((e: any) => e.cycle);
  const x = [];
  for (const cycle of cycles) {
    x.push({
      cycle: cycleSet.find((e: any) => e.id == cycle)?.name,
      data: [
        {
          ...team?.supervisorFeedBack.data?.find((e: any) => e.cycle == cycle),
          type: 'Supervisor FeedBack',
          link: `/webux/my-goals/goals/user/${user?.goalHolderId}/${user?.name}/${user?.userId}?cycle=${cycle}`,
        },
        {
          ...team?.peerReviews.data?.find((e: any) => e.cycle == cycle),
          type: 'Peer Reviews',
          link:
            +user?.userId === +userId
              ? `/webux/peer-reviews?cycle=${cycle}`
              : `/webux/peer-reviews-approve/${user?.userId}/${user?.name}?cycle=${cycle}`,
        },
        {
          ...team?.internalCustomers.data?.find((e: any) => e.cycle == cycle),
          type: 'Internal Customers',
          link: `/webux/internal-customers?cycle=${cycle}${
            +user?.userId !== +userId ? `&userId=${user?.userId}` : ''
          }`,
        },
        {
          ...team?.teamPerformance.data?.find((e: any) => e.cycle == cycle),
          type: 'Team Performance',
          link: `/webux/my-goals/goals/team/${team.goalHolderId}/${team?.teamName}/${team.teamId}?cycle=${cycle}`,
        },
      ],
    });
  }
  return x;
};

export const PerformanceResultsPage: FC = () => {
  const [data, setData] = useState<
    | {
        cycle?: number;
        userId: number;
        name: string;
        image: string;
        goalHolderId?: string;
        teamId: number | undefined;
        cycleClose: boolean | undefined;
        goalSummaryId: number | undefined;
        me: boolean | undefined;
        finalCommentSubmit: boolean | undefined;
        teams: any[];
      }
    | undefined
  >();
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [cycle, setCycle] = useQueryParam('cycle', ArrayParam);
  const cycleRef = useRef(cycle);
  const user = useUserInfo();
  const params = useParams<{ employeeId: string }>();
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [form] = Form.useForm();
  const PerformanceResultsColumns = useMemo(
    () => [
      {
        title: 'Component',
        dataIndex: 'type',
        key: 'type',
        // eslint-disable-next-line react/display-name
        render: (title: Text, record: any) => (
          <FlexBox>
            <Text style={{ marginRight: '2%' }}>
              <Link target={'_blank'} to={record?.link}>
                {title}
              </Link>
            </Text>
          </FlexBox>
        ),
      },
      {
        title: 'Progress',
        dataIndex: 'approved',
        key: 'approved',
        width: '250px',
        // eslint-disable-next-line react/display-name
        render: (title: Text, record: any) => (
          <Progress
            percent={
              +((record?.approved / (record?.pending + record?.approved)) * 100 ?? 0).toFixed(0)
            }
          />
        ),
      },
      {
        title: 'Weight',
        dataIndex: 'percentage',
        key: 'percentage',
        width: '150px',
      },
      {
        title: 'Total Marks',
        dataIndex: 'answer',
        key: 'answer',
        width: '150px',
        // eslint-disable-next-line react/display-name
        render: (title: Text, record: any) => (
          <Typography>
            {typeof record?.answer === 'string'
              ? record?.answer
              : `${(record?.answer ?? 0).toFixed(2)}%`}
          </Typography>
        ),
      },
    ],
    [],
  );

  const connection = useConnection();
  const history1 = useHistory();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const prePublish = useCallback(
    (teams: { goalSummaryId: number; teamId: number }[], name: string) => {
      Modal.confirm({
        title: 'Publish Performance Result',
        icon: <ExclamationCircleOutlined />,
        content: `are you sure you want to publish performance results for ${name}?`,
        okText: 'Publish',
        okType: 'primary',
        onOk() {
          setLoading(true);
          Promise.all(
            teams.map((team) =>
              connection.patch(`goals-summary/cycle-closure/${team.goalSummaryId}`, {
                teamId: team.teamId,
              }),
            ),
          )
            .then(() => setLoading1(!loading1))
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    // eslint-disable-next-line
    [connection],
  );

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const feedbackPublish = useCallback(() => {
    Modal.confirm({
      title: 'Publish Performance Feedback',
      icon: <ExclamationCircleOutlined />,
      content: `are you sure you want to publish your performance feedback?`,
      okText: 'Publish',
      okType: 'primary',
      onOk() {
        setLoading(true);
        connection
          .patch(`goals-summary/submit-comment/${cycle}`)
          .then(() => setLoading1(!loading1))
          .catch((e) => console.log(e))
          .finally(() => setLoading(false));
      },
      onCancel() {
        console.log('Cancel');
      },
    });
    // eslint-disable-next-line
  }, [connection, cycle]);

  const createComment = useCallback(
    (goalSummeryId: number, data: any) => {
      connection
        .patch(`goals-summary/feedback/${goalSummeryId}`, data)
        .catch((e) => console.log(e));
    },
    [connection],
  );

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle([value.closestCycle.id + ''], 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    if (cycle) {
      setLoading(true);
      connection
        .get(`users/overall-score/user/${params.employeeId}/cycle?cycle=${cycle}`)
        .then((res: any) => {
          setData(res.response);
        })
        .catch(() => {
          history1.push('/webux/dashboard');
          setLoading(false);
        })
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
          }, 600),
        );
    }
    // eslint-disable-next-line
  }, [connection, cycle, user?.userId, loading1, params.employeeId]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title={`${data?.name ?? ''} Performance Result`}
        subTitle="View performance result details"
        onBack={() => history1.goBack()}
        breadcrumb={{
          items: [
            {
              path: '',
              title: `Performance Result / ${data?.name ?? ''}`,
            },
          ],
        }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox style={{ justifyContent: 'space-between' }}>
            {/*<CycleToggle*/}
            {/*  value={parseInt(`${cycle}`)}*/}
            {/*  onChange={(value) => setCycle(value, 'replace')}*/}
            {/*  data={cycles}*/}
            {/*/>*/}
            <FlexBox>
              <MultipleToggle
                value={cycle?.map((e) => parseInt(`${e}`)) ?? []}
                data={cycles}
                onChange={(value) =>
                  setCycle(
                    value?.map((e) => e + ''),
                    'replace',
                  )
                }
              />
            </FlexBox>
            {!data?.teams.find(
              (y) =>
                !!y.supervisorFeedBack?.data ||
                !!y.peerReviews?.data ||
                !!y.internalCustomers?.data ||
                !!y.teamPerformance?.data,
            ) &&
              (!data?.cycleClose && data?.teams?.some((t) => t.supervisingTeam) ? (
                <Button
                  type="primary"
                  icon={<PoweroffOutlined />}
                  size="small"
                  disabled={
                    !!data.teams
                      .filter((e) => e.supervisingTeam)
                      .find(
                        (e) =>
                          e.comment?.strengthsOfThEmployee === '' ||
                          e.comment?.areasNeededToBeImproved === '' ||
                          e.comment?.individualDevelopmentPlan === '' ||
                          e.comment?.overallCommentsBySupervisor === '' ||
                          e.comment?.grade === '',
                      ) ||
                    (!!data?.teams.find(
                      (y) =>
                        !!y.supervisorFeedBack && typeof y.supervisorFeedBack?.answer !== 'string',
                    ) &&
                      !!data?.teams.find(
                        (y) => !!y.supervisorFeedBack && y.supervisorFeedBack?.pending !== 0,
                      )) ||
                    (!!data?.teams.find(
                      (y) => !!y.peerReviews && typeof y.peerReviews?.answer !== 'string',
                    ) &&
                      !!data?.teams.find((y) => !!y.peerReviews && y.peerReviews?.pending !== 0)) ||
                    (!!data?.teams.find(
                      (y) =>
                        !!y.internalCustomers && typeof y.internalCustomers?.answer !== 'string',
                    ) &&
                      !!data?.teams.find(
                        (y) => !!y.internalCustomers && y.internalCustomers?.pending !== 0,
                      )) ||
                    (!!data?.teams.find(
                      (y) => !!y.teamPerformance && typeof y.teamPerformance?.answer !== 'string',
                    ) &&
                      !!data?.teams.find(
                        (y) => !!y.teamPerformance && y.teamPerformance?.pending !== 0,
                      ))
                  }
                  onClick={() =>
                    prePublish(
                      data.teams
                        .filter((t) => t.supervisingTeam)
                        .map((t) => ({
                          goalSummaryId: t.goalSummaryId ?? 0,
                          teamId: t.teamId ?? 0,
                        })),
                      data.name,
                    )
                  }>
                  Publish Results
                </Button>
              ) : (
                <>
                  {data?.me && !data?.finalCommentSubmit && data?.cycleClose && (
                    <Button
                      type="primary"
                      icon={<PoweroffOutlined />}
                      size="small"
                      disabled={
                        data.teams.find((e) => e.comment.userFeedback === '') ||
                        data.teams.find((e) => e.comment.inhibitingFactors === '') ||
                        data.teams.find((e) => e.comment.facilitatingFactors === '')
                      }
                      onClick={() => feedbackPublish()}>
                      User Feedback Publish
                    </Button>
                  )}
                </>
              ))}
          </FlexBox>
          <Spin spinning={loading}>
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: 25 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Space size={24} align={'start'}>
                  <UserAvatar type={'team'} size={80} src={data?.image ?? ''} />
                  <Space direction={'vertical'}>
                    <Space direction={'vertical'} size={0}>
                      <Text>Final Score</Text>
                      <Typography.Title>
                        {data?.teams.find(
                          (y) =>
                            typeof y.supervisorFeedBack?.answer === 'string' ||
                            typeof y.peerReviews?.answer === 'string' ||
                            typeof y.internalCustomers?.answer === 'string' ||
                            typeof y.teamPerformance?.answer === 'string',
                        ) ? (
                          <Tag icon={<ClockCircleOutlined />} color="default">
                            Pending
                          </Tag>
                        ) : (
                          `${fullMark(data?.teams ?? []).toFixed(2)}%`
                        )}
                      </Typography.Title>
                      {/*<Tag color={e?.teamType?.color}>{e?.teamType?.name}</Tag>*/}
                    </Space>
                    {/*<Typography.Paragraph>{user?.description}</Typography.Paragraph>*/}
                  </Space>
                </Space>
              </div>
            </div>
            <Divider style={{ marginTop: 0, marginBottom: 5 }} />
            <Col>
              {data?.teams.find((y) => y.supervisorFeedBack !== undefined) !== undefined && (
                <Row style={{ marginBottom: 10 }}>
                  <Space size={20}>
                    <Row style={{ width: 300 }}>
                      <FlexBox style={{ width: 150 }}>
                        <Text>Supervisor Feedback</Text>
                      </FlexBox>
                    </Row>
                    <Text>
                      {data?.teams.find((y) => typeof y.supervisorFeedBack?.answer === 'string') ? (
                        <Tag icon={<ClockCircleOutlined />} color="default">
                          Pending
                        </Tag>
                      ) : (
                        `${sectionMark(
                          data?.teams.map((e) => ({
                            cyclePercentage: e.cyclePercentage,
                            section: e.supervisorFeedBack,
                          })) ?? [],
                        ).toFixed(2)}%`
                      )}
                    </Text>
                  </Space>
                </Row>
              )}
              {data?.teams.find((y) => y.peerReviews !== undefined) !== undefined && (
                <Row style={{ marginBottom: 10 }}>
                  <Space size={20}>
                    <Row style={{ width: 300 }}>
                      <FlexBox style={{ width: 150 }}>
                        <Text>Peer Review</Text>
                      </FlexBox>
                    </Row>
                    <Text>
                      {data.teams.find((y) => typeof y.peerReviews?.answer === 'string') ? (
                        <Tag icon={<ClockCircleOutlined />} color="default">
                          Pending
                        </Tag>
                      ) : (
                        `${sectionMark(
                          data.teams.map((e) => ({
                            cyclePercentage: e.cyclePercentage,
                            section: e.peerReviews,
                          })),
                        ).toFixed(2)}%`
                      )}
                    </Text>
                  </Space>
                </Row>
              )}
              {data?.teams.find((y) => y.internalCustomers !== undefined) !== undefined && (
                <Row style={{ marginBottom: 10 }}>
                  <Space size={20}>
                    <Row style={{ width: 300 }}>
                      <FlexBox style={{ width: 150 }}>
                        <Text>Internal Customer</Text>
                      </FlexBox>
                    </Row>
                    <Text>
                      {data.teams.find((y) => typeof y.internalCustomers?.answer === 'string') ? (
                        <Tag icon={<ClockCircleOutlined />} color="default">
                          Pending
                        </Tag>
                      ) : (
                        `${sectionMark(
                          data.teams.map((e) => ({
                            cyclePercentage: e.cyclePercentage,
                            section: e.internalCustomers,
                          })),
                        ).toFixed(2)}%`
                      )}
                    </Text>
                  </Space>
                </Row>
              )}
              {data?.teams.find((y) => y.teamPerformance !== undefined) !== undefined && (
                <Row style={{ marginBottom: 10 }}>
                  <Space size={20}>
                    <Row style={{ width: 300 }}>
                      <FlexBox style={{ width: 150 }}>
                        <Text>Team Performance</Text>
                      </FlexBox>
                    </Row>
                    <Text>
                      {data.teams.find((y) => typeof y.teamPerformance?.answer === 'string') ? (
                        <Tag icon={<ClockCircleOutlined />} color="default">
                          Pending
                        </Tag>
                      ) : (
                        `${sectionMark(
                          data.teams.map((e) => ({
                            cyclePercentage: e.cyclePercentage,
                            section: e.teamPerformance,
                          })),
                        ).toFixed(2)}%`
                      )}
                    </Text>
                  </Space>
                </Row>
              )}
            </Col>
            {data?.teams?.map((e) => (
              <Space direction={'vertical'} style={{ width: '100%' }} key={e.teamId} size={16}>
                <div
                  style={{ flex: 1, display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
                  <Row
                    style={{
                      alignItems: 'center',
                      marginTop: 10,
                      justifyContent: 'space-between',
                    }}>
                    <Space>
                      <ControlOutlined style={{ color: 'black', fontSize: 20 }} />
                      <Typography.Title level={5}>{e?.teamName}</Typography.Title>
                    </Space>
                    <Space>
                      <Typography.Title level={5}>
                        Allocated Percentage :- {e.cyclePercentage.toFixed(2)}%
                      </Typography.Title>
                    </Space>
                  </Row>
                  <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                  {data?.teams.find(
                    (y) =>
                      !!y.supervisorFeedBack?.data ||
                      !!y.peerReviews?.data ||
                      !!y.internalCustomers?.data ||
                      !!y.teamPerformance?.data,
                  ) ? (
                    dataSet(
                      e,
                      cycles,
                      {
                        goalHolderId: data?.goalHolderId,
                        name: data.name,
                        userId: data?.userId,
                      },
                      user?.userId,
                    ).map((x, index) => (
                      <div
                        key={index}
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          marginBottom: 10,
                          paddingLeft: 40,
                        }}>
                        <Row
                          style={{
                            alignItems: 'center',
                            marginTop: 10,
                            justifyContent: 'space-between',
                          }}>
                          <Space>
                            <Typography.Title level={5}>Cycle :- {x?.cycle}</Typography.Title>
                          </Space>
                          <Space>
                            <Typography.Title level={5}>
                              Allocated Percentage :- {x.data[0].cyclePercentage.toFixed(2)}%
                            </Typography.Title>
                          </Space>
                        </Row>
                        <Divider style={{ marginTop: 0, marginBottom: 20 }} />
                        <Table
                          columns={PerformanceResultsColumns}
                          dataSource={x.data
                            .filter((e1) => e1.answer !== undefined)
                            .map((n, i) => ({
                              ...n,
                              key: i,
                            }))}
                          indentSize={70}
                          pagination={false}
                          size={'small'}
                        />
                      </div>
                    ))
                  ) : (
                    <Table
                      columns={PerformanceResultsColumns}
                      dataSource={[
                        {
                          ...e?.supervisorFeedBack,
                          type: 'Supervisor FeedBack',
                          link: `/webux/my-goals/goals/user/${data?.goalHolderId}/${data.name}/${data?.userId}?cycle=${data.cycle}`,
                        },
                        {
                          ...e?.peerReviews,
                          type: 'Peer Reviews',
                          link:
                            +(user?.userId ?? 0) === +data?.userId
                              ? `/webux/peer-reviews?cycle=${data.cycle}`
                              : `/webux/peer-reviews-approve/${data?.userId}/${data?.name}?cycle=${data.cycle}`,
                        },
                        {
                          ...e?.internalCustomers,
                          type: 'Internal Customers',
                          link: `/webux/internal-customers?cycle=${data.cycle}${
                            +(user?.userId ?? 0) !== +data?.userId ? `&userId=${data?.userId}` : ''
                          }`,
                        },
                        {
                          ...e?.teamPerformance,
                          type: 'Team Performance',
                          link: `/webux/my-goals/goals/team/${e.goalHolderId}/${e?.teamName}/${e.teamId}?cycle=${data.cycle}`,
                        },
                      ]
                        .filter((e1) => e1.answer !== undefined)
                        .map((n, i) => ({
                          ...n,
                          key: i,
                        }))}
                      expandable={{}}
                      indentSize={70}
                      pagination={false}
                      size={'small'}
                      // summary={() => {
                      //   return (
                      //     <>
                      //       <Table.Summary.Row>
                      //         <Table.Summary.Cell colSpan={6} index={1} />
                      //         <Table.Summary.Cell index={2} colSpan={1}>
                      //           Total
                      //         </Table.Summary.Cell>
                      //         <Table.Summary.Cell index={3}>
                      //           <div
                      //             style={{
                      //               width: '50%',
                      //               display: 'flex',
                      //               justifyContent: 'flex-start',
                      //             }}>
                      //             <Typography>5</Typography>
                      //           </div>
                      //         </Table.Summary.Cell>
                      //       </Table.Summary.Row>
                      //     </>
                      //   );
                      // }}
                    />
                  )}
                  {!data?.teams.find(
                    (y) =>
                      !!y.supervisorFeedBack?.data ||
                      !!y.peerReviews?.data ||
                      !!y.internalCustomers?.data ||
                      !!y.teamPerformance?.data,
                  ) &&
                    (e.supervisingTeam ? (
                      <>
                        <Space style={{ paddingTop: '30px' }}>
                          <Typography.Title level={5}>Supervisor Analysis</Typography.Title>
                        </Space>
                        {data?.cycleClose ? (
                          <FlexBox direction={'vertical'}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              <div>
                                <Text strong>Grade</Text>
                              </div>
                              <div
                                style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                                <Text>{e.comment.grade}</Text>
                              </div>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              <div>
                                <Text strong>Strengths of the Employee</Text>
                              </div>
                              <div
                                style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                                <Text>{e.comment.strengthsOfThEmployee}</Text>
                              </div>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              <div>
                                <Text strong>Areas to be Improved</Text>
                              </div>
                              <div
                                style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                                <Text>{e.comment.areasNeededToBeImproved}</Text>
                              </div>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              <div>
                                <Text strong>Individual Development Plan</Text>
                              </div>
                              <div
                                style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                                <Text>{e.comment.individualDevelopmentPlan}</Text>
                              </div>
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              <div>
                                <Text strong>Overall Comments by Supervisor</Text>
                              </div>
                              <div
                                style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                                <Text>{e.comment.overallCommentsBySupervisor}</Text>
                              </div>
                            </div>
                          </FlexBox>
                        ) : (
                          <FlexBox>
                            <Form form={form}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Grade</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <Select
                                    style={{ width: 120 }}
                                    placeholder="Add Grade"
                                    value={e.comment.grade}
                                    onSelect={(e2) => {
                                      setData({
                                        ...data,
                                        teams: data.teams.map((e1) => {
                                          if (e1.goalSummaryId === e.goalSummaryId) {
                                            return {
                                              ...e1,
                                              comment: {
                                                ...e1.comment,
                                                grade: e2,
                                              },
                                            };
                                          } else {
                                            return e1;
                                          }
                                        }),
                                      });
                                      createComment(e.goalSummaryId, {
                                        grade: e2,
                                      });
                                    }}
                                    options={[
                                      { value: '1', label: '1' },
                                      { value: '2', label: '2' },
                                      { value: '3', label: '3' },
                                      { value: '4', label: '4' },
                                      { value: '5', label: '5' },
                                    ]}
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Strengths of the Employee</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <TextArea
                                    rows={3}
                                    placeholder="Add Strengths of the Employee"
                                    allowClear
                                    value={e.comment.strengthsOfThEmployee}
                                    onChange={(e2) =>
                                      setData({
                                        ...data,
                                        teams: data.teams.map((e1) => {
                                          if (e1.goalSummaryId === e.goalSummaryId) {
                                            return {
                                              ...e1,
                                              comment: {
                                                ...e1.comment,
                                                strengthsOfThEmployee: e2.target.value,
                                              },
                                            };
                                          } else {
                                            return e1;
                                          }
                                        }),
                                      })
                                    }
                                    onBlur={(e1) =>
                                      createComment(e.goalSummaryId, {
                                        strengthsOfThEmployee: e1.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Areas to be Improved</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <TextArea
                                    rows={3}
                                    placeholder="Add Areas to be Improved"
                                    allowClear
                                    value={e.comment.areasNeededToBeImproved}
                                    onChange={(e2) =>
                                      setData({
                                        ...data,
                                        teams: data.teams.map((e1) => {
                                          if (e1.goalSummaryId === e.goalSummaryId) {
                                            return {
                                              ...e1,
                                              comment: {
                                                ...e1.comment,
                                                areasNeededToBeImproved: e2.target.value,
                                              },
                                            };
                                          } else {
                                            return e1;
                                          }
                                        }),
                                      })
                                    }
                                    onBlur={(e1) =>
                                      createComment(e.goalSummaryId, {
                                        areasNeededToBeImproved: e1.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Individual Development Plan</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <TextArea
                                    rows={3}
                                    placeholder="Add Individual Development Plan"
                                    allowClear
                                    value={e.comment.individualDevelopmentPlan}
                                    onChange={(e2) =>
                                      setData({
                                        ...data,
                                        teams: data.teams.map((e1) => {
                                          if (e1.goalSummaryId === e.goalSummaryId) {
                                            return {
                                              ...e1,
                                              comment: {
                                                ...e1.comment,
                                                individualDevelopmentPlan: e2.target.value,
                                              },
                                            };
                                          } else {
                                            return e1;
                                          }
                                        }),
                                      })
                                    }
                                    onBlur={(e1) =>
                                      createComment(e.goalSummaryId, {
                                        individualDevelopmentPlan: e1.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Overall Comments by Supervisor</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <TextArea
                                    rows={3}
                                    placeholder="Add Overall Comments by Supervisor"
                                    allowClear
                                    value={e.comment.overallCommentsBySupervisor}
                                    onChange={(e2) =>
                                      setData({
                                        ...data,
                                        teams: data.teams.map((e1) => {
                                          if (e1.goalSummaryId === e.goalSummaryId) {
                                            return {
                                              ...e1,
                                              comment: {
                                                ...e1.comment,
                                                overallCommentsBySupervisor: e2.target.value,
                                              },
                                            };
                                          } else {
                                            return e1;
                                          }
                                        }),
                                      })
                                    }
                                    onBlur={(e1) =>
                                      createComment(e.goalSummaryId, {
                                        overallCommentsBySupervisor: e1.target.value,
                                      })
                                    }
                                  />
                                </div>
                              </div>
                            </Form>
                          </FlexBox>
                        )}
                        {e.comment.userFeedback !== '' && data?.finalCommentSubmit && (
                          <>
                            <Space style={{ paddingTop: '30px' }}>
                              <Typography.Title level={5}>
                                Employee Comment on Evaluation Outcome
                              </Typography.Title>
                            </Space>
                            <FlexBox direction={'vertical'}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Evaluation Outcome Comment</Text>
                                </div>
                                <div style={{ width: '60vw', paddingTop: '5px' }}>
                                  <Text>{e.comment.userFeedback}</Text>
                                </div>
                                {e.comment.inhibitingFactors !== '' && (
                                  <>
                                    <div>
                                      <Text strong>Inhibiting Factors</Text>
                                    </div>
                                    <div
                                      style={{
                                        width: '60vw',
                                        paddingTop: '5px',
                                        paddingBottom: '20px',
                                      }}>
                                      <Text>
                                        {e.comment.inhibitingFactors === ''
                                          ? ''
                                          : e.comment.inhibitingFactors &&
                                            !!e.comment.inhibitingFactors?.replace(regex, '').length
                                          ? ReactHtmlParser(e.comment.inhibitingFactors)
                                          : ''}
                                      </Text>
                                    </div>
                                  </>
                                )}
                                {e.comment.facilitatingFactors !== '' && (
                                  <>
                                    <div>
                                      <Text strong>Facilitating Factors</Text>
                                    </div>
                                    <div
                                      style={{
                                        width: '60vw',
                                        paddingTop: '5px',
                                        paddingBottom: '20px',
                                      }}>
                                      <Text>
                                        {e.comment.facilitatingFactors === ''
                                          ? ''
                                          : e.comment.facilitatingFactors &&
                                            !!e.comment.facilitatingFactors?.replace(regex, '')
                                              .length
                                          ? ReactHtmlParser(e.comment.facilitatingFactors)
                                          : ''}
                                      </Text>
                                    </div>
                                  </>
                                )}
                              </div>
                            </FlexBox>
                          </>
                        )}
                      </>
                    ) : typeof e.supervisorFeedBack?.answer === 'string' ||
                      typeof e.peerReviews?.answer === 'string' ||
                      typeof e.internalCustomers?.answer === 'string' ||
                      typeof e.teamPerformance?.answer === 'string' ? (
                      <></>
                    ) : data.me ? (
                      <>
                        <Space style={{ paddingTop: '30px' }}>
                          <Typography.Title level={5}>Supervisor Analysis</Typography.Title>
                        </Space>
                        <FlexBox direction={'vertical'}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Grade</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.grade}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Strengths of the Employee</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.strengthsOfThEmployee}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Areas to be Improved</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.areasNeededToBeImproved}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Individual Development Plan</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.individualDevelopmentPlan}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Overall Comments by Supervisor</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.overallCommentsBySupervisor}</Text>
                            </div>
                          </div>
                        </FlexBox>
                        <Space style={{ paddingTop: '30px' }}>
                          <Typography.Title level={5}>My Analysis</Typography.Title>
                        </Space>
                        <FlexBox>
                          <Form form={form}>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}>
                              {data?.finalCommentSubmit ? (
                                <>
                                  <div>
                                    <Text strong>Evaluation Outcome Comment</Text>
                                  </div>
                                  <div
                                    style={{
                                      width: '60vw',
                                      paddingTop: '5px',
                                      paddingBottom: '20px',
                                    }}>
                                    <Text>{e.comment.userFeedback}</Text>
                                  </div>
                                  {e.comment.inhibitingFactors !== '' && (
                                    <>
                                      <div>
                                        <Text strong>Inhibiting Factors</Text>
                                      </div>
                                      <div
                                        style={{
                                          width: '60vw',
                                          paddingTop: '5px',
                                          paddingBottom: '20px',
                                        }}>
                                        <Text>
                                          {e.comment.inhibitingFactors === ''
                                            ? ''
                                            : e.comment.inhibitingFactors &&
                                              !!e.comment.inhibitingFactors?.replace(regex, '')
                                                .length
                                            ? ReactHtmlParser(e.comment.inhibitingFactors)
                                            : ''}
                                        </Text>
                                      </div>
                                    </>
                                  )}
                                  {e.comment.facilitatingFactors !== '' && (
                                    <>
                                      <div>
                                        <Text strong>Facilitating Factors</Text>
                                      </div>
                                      <div
                                        style={{
                                          width: '60vw',
                                          paddingTop: '5px',
                                          paddingBottom: '20px',
                                        }}>
                                        <Text>
                                          {e.comment.facilitatingFactors === ''
                                            ? ''
                                            : e.comment.facilitatingFactors &&
                                              !!e.comment.facilitatingFactors?.replace(regex, '')
                                                .length
                                            ? ReactHtmlParser(e.comment.facilitatingFactors)
                                            : ''}
                                        </Text>
                                      </div>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  <div>
                                    <Text strong>Evaluation Outcome Comment</Text>
                                  </div>
                                  <div
                                    style={{
                                      width: '60vw',
                                      paddingTop: '5px',
                                      paddingBottom: '20px',
                                    }}>
                                    <TextArea
                                      rows={3}
                                      placeholder="User Feedback"
                                      allowClear
                                      value={e.comment.userFeedback}
                                      onChange={(e2) =>
                                        setData({
                                          ...data,
                                          teams: data.teams.map((e1) => {
                                            if (e1.goalSummaryId === e.goalSummaryId) {
                                              return {
                                                ...e1,
                                                comment: {
                                                  ...e1.comment,
                                                  userFeedback: e2.target.value,
                                                },
                                              };
                                            } else {
                                              return e1;
                                            }
                                          }),
                                        })
                                      }
                                      onBlur={(e1) =>
                                        createComment(e.goalSummaryId, {
                                          userFeedback: e1.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                  <div>
                                    <Text strong>Inhibiting Factors</Text>
                                  </div>
                                  <div
                                    style={{
                                      width: '60vw',
                                      paddingTop: '5px',
                                      paddingBottom: '20px',
                                    }}>
                                    <RichText
                                      placeholder={'Add your inhibiting factors'}
                                      value={e.comment.inhibitingFactors}
                                      maxLength={10000}
                                      onChange={(e2) =>
                                        setData({
                                          ...data,
                                          teams: data.teams.map((e1) => {
                                            if (e1.goalSummaryId === e.goalSummaryId) {
                                              return {
                                                ...e1,
                                                comment: {
                                                  ...e1.comment,
                                                  inhibitingFactors: e2,
                                                },
                                              };
                                            } else {
                                              return e1;
                                            }
                                          }),
                                        })
                                      }
                                      onBlur={() => {
                                        createComment(e.goalSummaryId, {
                                          inhibitingFactors: e.comment.inhibitingFactors,
                                        });
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <Text strong>Facilitating Factors</Text>
                                  </div>
                                  <div
                                    style={{
                                      width: '60vw',
                                      paddingTop: '5px',
                                      paddingBottom: '20px',
                                    }}>
                                    <RichText
                                      placeholder={'Add your facilitating factors'}
                                      value={e.comment.facilitatingFactors}
                                      maxLength={10000}
                                      onChange={(e2) =>
                                        setData({
                                          ...data,
                                          teams: data.teams.map((e1) => {
                                            if (e1.goalSummaryId === e.goalSummaryId) {
                                              return {
                                                ...e1,
                                                comment: {
                                                  ...e1.comment,
                                                  facilitatingFactors: e2,
                                                },
                                              };
                                            } else {
                                              return e1;
                                            }
                                          }),
                                        })
                                      }
                                      onBlur={() => {
                                        createComment(e.goalSummaryId, {
                                          facilitatingFactors: e.comment.facilitatingFactors,
                                        });
                                      }}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </Form>
                        </FlexBox>
                      </>
                    ) : (
                      <>
                        <Space style={{ paddingTop: '30px' }}>
                          <Typography.Title level={5}>Supervisor Analysis</Typography.Title>
                        </Space>
                        <FlexBox direction={'vertical'}>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Grade</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.grade}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Strengths of the Employee</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.strengthsOfThEmployee}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Areas to be Improved</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.areasNeededToBeImproved}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Individual Development Plan</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.comment.individualDevelopmentPlan}</Text>
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                            }}>
                            <div>
                              <Text strong>Overall Comments by Supervisor</Text>
                            </div>
                            <div
                              style={{ width: '60vw', paddingTop: '5px', paddingBottom: '10px' }}>
                              <Text>{e.overallCommentsBySupervisor}</Text>
                            </div>
                          </div>
                        </FlexBox>
                        {data?.finalCommentSubmit && (
                          <>
                            <Space style={{ paddingTop: '30px' }}>
                              <Typography.Title level={5}>
                                Employee Comment on Evaluation Outcome
                              </Typography.Title>
                            </Space>
                            <FlexBox direction={'vertical'}>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                }}>
                                <div>
                                  <Text strong>Evaluation Outcome Comment</Text>
                                </div>
                                <div
                                  style={{
                                    width: '60vw',
                                    paddingTop: '5px',
                                    paddingBottom: '10px',
                                  }}>
                                  <Text>{e.comment.userFeedback}</Text>
                                </div>
                                {e.comment.inhibitingFactors !== '' && (
                                  <>
                                    <div>
                                      <Text strong>Inhibiting Factors</Text>
                                    </div>
                                    <div
                                      style={{
                                        width: '60vw',
                                        paddingTop: '5px',
                                        paddingBottom: '20px',
                                      }}>
                                      <Text>
                                        {e.comment.inhibitingFactors === ''
                                          ? ''
                                          : e.comment.inhibitingFactors &&
                                            !!e.comment.inhibitingFactors?.replace(regex, '').length
                                          ? ReactHtmlParser(e.comment.inhibitingFactors)
                                          : ''}
                                      </Text>
                                    </div>
                                  </>
                                )}
                                {e.comment.facilitatingFactors !== '' && (
                                  <>
                                    <div>
                                      <Text strong>Facilitating Factors</Text>
                                    </div>
                                    <div
                                      style={{
                                        width: '60vw',
                                        paddingTop: '5px',
                                        paddingBottom: '20px',
                                      }}>
                                      <Text>
                                        {e.comment.facilitatingFactors === ''
                                          ? ''
                                          : e.comment.facilitatingFactors &&
                                            !!e.comment.facilitatingFactors?.replace(regex, '')
                                              .length
                                          ? ReactHtmlParser(e.comment.facilitatingFactors)
                                          : ''}
                                      </Text>
                                    </div>
                                  </>
                                )}
                              </div>
                            </FlexBox>
                          </>
                        )}
                      </>
                    ))}
                </div>
              </Space>
            ))}
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
